import ClipLoader from "react-spinners/ClipLoader";
import React from "react";



const SIZE_MAP = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
};

export default function AppSpinner({
  size = "md",
  color = "var(--primary, #0ea5e9)",
  overlay = false,
  label = "Loading…",
  speed = 1,
  className = "",
}) {
  const pixelSize = typeof size === "number" ? size : SIZE_MAP[size] ?? 24;

  const spinner = (
    <div
      role="status"
      aria-label={label}
      className={`inline-flex items-center ${className}`}
    >
      <span className="sr-only">{label}</span>
      <ClipLoader size={pixelSize} color={color} speedMultiplier={speed} />
    </div>
  );

  if (!overlay) return spinner;

  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/10 backdrop-blur-sm">
      {spinner}
    </div>
  );
}
